module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customReport.title":"Custom Report - {reportName}","customReport.failedToLoad":"There was an issue loading this custom report.","customReport.backButtonText":"Back to reports","customReport.editButtonText":"Edit"}}')
  delete Component.options._Ctor
}
